'use client';
import Hooks from '@benzinga/hooks';
import { FullDataField, QuotesV3FieldsManager } from '@benzinga/quotes-v3-fields-manager';
import { SessionContext } from '@benzinga/session-context';
import React from 'react';

export const useScannerDefs = (callback?: (defs: FullDataField[]) => void) => {
  const session = React.useContext(SessionContext);
  const [scannerDefs, setScannerDefs] = React.useState(() =>
    session.getManager(QuotesV3FieldsManager).getCachedScannerDefs(),
  );
  const cb = callback ?? setScannerDefs;

  React.useEffect(() => {
    session.getManager(QuotesV3FieldsManager);
  }, [cb, session]);

  Hooks.useSubscriber(session.getManager(QuotesV3FieldsManager), event => {
    switch (event.type) {
      case 'quotes_fields:update':
        cb(event.fields);
        break;
    }
  });

  return scannerDefs;
};
